export default __webpack_public_path__ + "media/wallpaper/six_thumbnail_large-c32073f9.jpg";